enum ShippingCompany {
  ACL = "Arcelor Mittal",
  AFR = "AFR",
  ALI = "Alianza Navegacao e Logistica Ltda.",
  ANL = "Australian National Line",
  APL = "American Presidents Line",
  APM = "APM Terminals",
  ARK = "Arkas-International Cargo express",
  ASI = "Asiatic Shipping",
  AWS = "AWS",
  BOL = "Boluda Lines",
  BOR = "Borchard Lines",
  CCN = "CCNI",
  CFE = "Canary Feeder",
  CGM = "COMPAGNIE GENERALE MARITIME ET",
  CHL = "Container Hispania Lines S.A.",
  CHN = "China Shipping Container Lines Co",
  CMA = "CMA CGM",
  COE = "Cosco Container Lines Europe GmbH",
  CON = "CONTSHIP",
  COS = "Cosco Container Lines",
  CSV = "Compania Sud Americana de Vapores",
  CTE = "Compaqia Trasatlantica Espaqola S.A",
  DAA = "DELMAS",
  DAL = "Deutsche Afrika-Linien GMBH & Co",
  DAM = "DAMCO SPAIN",
  DGB = "Damighreb",
  DLM = "DELMAS",
  DMC = "D'AMICO",
  EAS = "EAS Lines",
  EGL = "Evergreen Line",
  EME = "Emes Shipping & Transport S.A.",
  FLW = "Spaflow",
  GPM = "GPM",
  GSL = "GS LINES TRANSPORTES MARITIMOS LDA",
  GSM = "GSM",
  HDS = "HAFEZ DARYA ARYA SHIPPING LINE",
  HJS = "Hanjin Shipping Co., Ltd.",
  HLC = "Hapag Lloyd Container Line",
  HML = "HATSU MARINE LINE",
  HMM = "Hyundai Merchant Marine Co., Ltd.",
  ISS = "ISS Shipping",
  JADE = "JADE",
  KKL = "K-Line",
  LQL = "Liquid Lines LLC",
  MAE = "MAERSKLINE",
  MSK = "Maersk",
  MLL = "MAERSKLINE",
  MCC = "MCC Transport",
  MES = "Messina",
  MFT = "Marfret Compagnie Maritime",
  MGU = "MARGUISA SHIP CO.",
  MMC = "Melfi Marine Corporation",
  MOL = "Mitsui OSK Lines Ltd.",
  MRG = "Marguisa",
  MSC = "Mediterranean Shipping Company SA",
  MUO = "Maritime United Operator",
  NDL = "NILEDUTCH LINE",
  NYK = "NYK Line",
  ONE = "Ocean Network Express",
  OOL = "Orient Overseas Container Line Ltd.",
  OPD = "Oldenburg-Portugiesische Dampfschiffs-Rhederei",
  OTH = "Other Company",
  PCI = "Portusline Containers Internacional",
  PYC = "A. Pérez y Cía, S.L",
  QNL = "Qatar Navigation Lines",
  RMS = "REMESA - ALGECIRAS",
  ROD = "Rodymar",
  ROM = "ROMOCEAN",
  SAF = "Safmarine Container Lines",
  SAM = "Samskip",
  SEA = "Sealand",
  SEN = "Senator Lines",
  SGL = "Seago Lines",
  SHI = "Shiama Line",
  SJK = "Sarjak Lines",
  SON = "Shipper Own Container",
  SUD = "Hamburg Sud",
  SUL = "Sullivan",
  TMI = "TRANSINSULAR (TRANSPORTES MARITIMOS INSULARES SA)",
  TMSA = "TMSA - Port Authority",
  TRM = "MAERSK ESPAÑA, TERMINAL DIVISION",
  TUR = "Turkon",
  UAS = "United Arab Shipping Co",
  UFS = "UNITED FEEDER SERVICES",
  UNI = "UNISHIPPING",
  UNK = "--",
  UFE = "Unifeeder",
  WEC = "WEC lines",
  XCL = "X-Press Container Line",
  YML = "Yang Ming Marine Transport Corp.",
  ZIM = "Zim Lines",
  OOC = "OOC",
  OOCL = "OOCL"
}

export default ShippingCompany;
